import { supabase } from '../supabase';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const DAYS = [
  { value: 0, label: 'Sunday' },
  { value: 1, label: 'Monday' },
  { value: 2, label: 'Tuesday' },
  { value: 3, label: 'Wednesday' },
  { value: 4, label: 'Thursday' },
  { value: 5, label: 'Friday' },
  { value: 6, label: 'Saturday' },
];

// Look up the auth.users id for a given email via the backend Admin API
// proxy. Returns null on any error.
export const lookupAuthUidByEmail = async (email) => {
  try {
    const { data: { session } } = await supabase.auth.getSession();
    const res = await fetch(`${BACKEND_URL}/api/auth/lookup-user`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${session?.access_token}` },
      body: JSON.stringify({ email }),
    });
    if (!res.ok) return null;
    const json = await res.json();
    return json.user_id || null;
  } catch {
    return null;
  }
};
